// Returns the timeslot and station data with generalized naming conventions
// so that it can be passed to the ItemSelection component
export function getGeneralizedItems(state) {
  const stationsData = state.stationsData;
  if (stationsData) {
    let timeslots = {};
    let items = {};
    stationsData.timeslots.forEach((timeslot) => {
      timeslots[timeslot.timeslotId] = {
        timeslotId: timeslot.timeslotId,
        displayDayBefore: timeslot.displayDayBefore,
        time: timeslot.time,
        moment: timeslot.moment,
        utc_moment: timeslot.utc_moment,
        availableItems: timeslot.availableStations,
        itemIds: timeslot.stationIds,
        addonIds: timeslot.addonIds,
        itemAvailable: {}
      };
    });
    Object.keys(stationsData.stations).forEach((stationId) => {
      const station = stationsData.stations[stationId];
      if (station !== undefined) {
        items[stationId] = {
          itemId: parseInt(stationId, 10),
          price: station.price,
          title: station.title,
          description: station.description,
          disabledDescription: '',
          helpText: station.helpText,
          stationExtra: station.participantExtra,
          isStation: true,
          is_movable: station.is_movable,
          is_refundable: station.is_refundable
        };
      }
    });
    return {
      timeslots,
      items
    };
  }
  return {
    timeslots: {},
    items: {}
  };
}

// Returns how many stations are selected in total
export function getNumSelectedStations(state) {
  let numSelected = 0;
  Object.keys(state.selectedStations).forEach((timeslotId) => {
    const timeslot = state.selectedStations[timeslotId];
    if (timeslot !== undefined) {
      Object.keys(timeslot).forEach((stationId) => {
        const quantity = timeslot[stationId];
        if (quantity !== undefined) {
          numSelected += quantity;
        }
      });
    }
  });
  return numSelected;
}

// Returns how many stations are selected for the given timeslot
export function getNumberOfStations(state, timeslotId) {
  let maxStations = 0;
  let numStations = 0;

  const objKeysForEach = (timeslot) => {
    return (stationId) => {
      const quantity = timeslot[stationId];
      numStations += quantity;
    };
  }

  for (let a in state.selectedStations) {
    numStations = 0;
    const timeslot = state.selectedStations[a];
    Object.keys(timeslot).forEach(objKeysForEach(timeslot));
    if (numStations > maxStations) maxStations = numStations;
  }

  return maxStations;
}

export function getNumberOfStationsInTimeslot(state, index) {

  let sortedTimeslots = [];
  
  for (let a in state.selectedStations) {
    sortedTimeslots.push(a);
  }

  sortedTimeslots.sort((a, b) => {
    if(a < b) return -1;
    else if(a > b) return 1;
    else return 0;
  })

  let timeslot = sortedTimeslots[index];

  let numStations = 0;
  for(let key in state.selectedStations[timeslot]) {
    numStations += state.selectedStations[timeslot][key];
  }

  return numStations;
}

// Returns the total number of people for that session.
export function getNumberOfHuman(state, timeslotId) {
  let maxHuman = 0;
  let numHuman = 0;

  const objKeysForEach = (timeslot, extraTimeslot) => {
    return (stationId) => {
      let quantity = extraTimeslot ? extraTimeslot[stationId] : 0;
      if (quantity !== undefined && quantity > 0) {
        numHuman += quantity;
      } else {
        quantity = timeslot[stationId];
        if (quantity !== undefined) {
          numHuman += quantity;
        }
      }
    };
  }

  for (let b in state.selectedStations) {
    if (state.selectedStations.hasOwnProperty(b)) {
      numHuman = 0;
      const timeslot = state.selectedStations[b];
      const extraTimeslot = state.selectedExtra[b];
      if (timeslot !== undefined) {
        Object.keys(timeslot).forEach(objKeysForEach(timeslot, extraTimeslot));
        if (numHuman > maxHuman) maxHuman = numHuman;
      }
    }
  }
  return maxHuman;
}
